/**
 * Single source of truth for the pricing plans' price and billing period.
 *
 * Both the visible prices (`PricingPageClient`) and the Product JSON-LD
 * (`pricing/page.tsx`) derive from this list, so a plan can no longer be
 * priced differently in the markup than on the page, and a recurring plan
 * cannot lose its `billingDuration` at the call site.
 *
 * The prose that mentions a price (e.g. `Pricing.metaDescription`,
 * `Pricing.faq.priceNote` in `messages/*.json`) is translated copy and is NOT
 * bound to this list — grep the messages when a price changes.
 */
export interface PricingPlan {
  id: "starter" | "sevenDay" | "monthly" | "lifetime";
  /** Numeric price as a string, without a currency symbol. */
  price: string;
  /** Billing period for subscriptions, e.g. "P1M" for a monthly plan. */
  billingDuration?: string;
}

export const PRICING_PLANS: readonly PricingPlan[] = [
  { id: "starter", price: "0" },
  { id: "sevenDay", price: "4.9" },
  { id: "monthly", price: "9.9", billingDuration: "P1M" },
  { id: "lifetime", price: "49.9" },
];
